import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/index'
import Home from '@/views/home'
import About from '@/views/about'
import News from '@/views/news'
import GetPlan from '@/views/getPlan'
import Service from '@/views/service'
import Solve from '@/views/solve'
import NewsInfo from '@/views/newsInfo'
import LegalNotice from '@/views/legalNotice'
import Product from '@/views/product'
import EnglishWebsit from '@/views/English-page'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/', // 首页
      name: 'Index',
      component: Index,
      children: [
        {
          path: '/',
          name: 'Home',
          component: Home
        },
        {
          path: '/product', // 产品
          name: 'Product',
          component: Product
        },
        {
          path: '/solve', // 解决方案
          name: 'Solve',
          component: Solve
        },
        {
          path: '/about', // 关于公司
          name: 'About',
          component: About
        },
        {
          path: '/news',
          name: 'News',
          component: News
        },
        {
          path: '/getPlan',
          name: 'GetPlan',
          component: GetPlan
        },
        {
          path: '/service',
          name: 'Service',
          component: Service
        },
        {
          path: '/newsInfo',
          name: 'NewsInfo',
          component: NewsInfo
        },
        {
          path: '/declaration',
          name: 'LegalNotice',
          component: LegalNotice
        }
      ]
    },
    {
      path: '/English_websit',
      name: 'EnglishWebsit',
      component: EnglishWebsit
    }
  ],
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return { x: 0, y: 0 }
  }
})
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js